import React, { useState, useEffect } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { TESTIMONIALS } from '../mock';

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % TESTIMONIALS.length), 7000);
    return () => clearInterval(t);
  }, []);
  const item = TESTIMONIALS[i];
  return (
    <section className="section-pad" style={{ background: 'var(--warm-white)' }}>
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="eyebrow mb-3 reveal">Kind Words</div>
        <h2 className="section-title mb-10 reveal">What Our Clients Are Saying</h2>

        <div className="card-soft p-8 md:p-12 relative overflow-hidden">
          <Quote className="w-10 h-10 text-[color:var(--blush-pink)] mx-auto mb-4" strokeWidth={1.4} />
          <p key={i} className="text-lg md:text-xl font-serif-display italic text-[color:var(--deep-sage)] leading-relaxed animate-fade-in">
            “{item.quote}”
          </p>
          <div className="mt-6 text-sm uppercase tracking-[0.24em] text-[color:var(--sage-dark)]">— {item.author}</div>

          <div className="mt-8 flex items-center justify-center gap-4">
            <button aria-label="Previous" onClick={() => setI((i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)} className="w-9 h-9 rounded-full border flex items-center justify-center text-[color:var(--sage-dark)] hover:bg-[color:var(--sage-green)] hover:text-white transition" style={{ borderColor: 'var(--soft-border)' }}>
              <ChevronLeft className="w-4 h-4" />
            </button>
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, idx) => (
                <button key={idx} onClick={() => setI(idx)} aria-label={`Testimonial ${idx+1}`} className={`h-2 rounded-full transition-all ${idx === i ? 'w-8 bg-[color:var(--dusty-rose)]' : 'w-2 bg-[color:var(--soft-border)]'}`} />
              ))}
            </div>
            <button aria-label="Next" onClick={() => setI((i + 1) % TESTIMONIALS.length)} className="w-9 h-9 rounded-full border flex items-center justify-center text-[color:var(--sage-dark)] hover:bg-[color:var(--sage-green)] hover:text-white transition" style={{ borderColor: 'var(--soft-border)' }}>
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
